// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/scss/style.scss
// module id = 167
// module chunks = 0